var AutograderDemo = require("components/writing/evaluations/AutograderDemo.js")

class OnboardingStageAutograderDemo extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	renderSetButton() {
		return (
			<div className="text-right nextStage">
				<button className="btn buttonPrimary setButton"
					onClick={ this.props.onComplete }>
					Next
				</button>
			</div>
		)
	}

	renderAutograderDemo() {
		return <AutograderDemo />
	}

	render() {
		return (
			<div className="onboardingStage onboardingStageAutograderDemo clearfix">
				{ this.renderAutograderDemo() }
				{ this.renderSetButton() }
			</div>
		);
	}
}


OnboardingStageAutograderDemo.propTypes = StrictPropTypes({});

module.exports = OnboardingStageAutograderDemo;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingStageAutograderDemo.js